import api from './api';

export const leadService = {
  getAll: (params = {}) => api.get('/leads/', { params }),
  getById: (id) => api.get(`/leads/${id}`),
  create: (data) => api.post('/leads/', data),
  update: (id, data) => api.put(`/leads/${id}`, data),
  updateStatus: (id, status, notes) => api.put(`/leads/${id}/status`, { status, notes }),
  convertToCustomer: (id) => api.post(`/leads/${id}/convert-to-customer`),
  addContactLog: (id, contactLog) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('🔍 Adding contact log:', { id, contactLog, baseURL: api.defaults.baseURL, fullURL: `${api.defaults.baseURL}/leads/${id}/contact-logs` });
    }
    return api.post(`/leads/${id}/contact-logs`, contactLog);
  },
  updateContactLog: (id, logIndex, contactLog) => api.put(`/leads/${id}/contact-logs/${logIndex}`, contactLog),
  deleteContactLog: (id, logIndex) => api.delete(`/leads/${id}/contact-logs/${logIndex}`),
  delete: (id) => api.delete(`/leads/${id}`),
  getStats: () => api.get('/leads/stats/overview'),
};
